var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"scrollerWrapper"}},[_c('div',{attrs:{"id":"scroller"}},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }